module.exports = __webpack_public_path__ + "media/images/hexa4-672d8ce49e4705f31d609a0bc2642cc5.png";